interface ScoreRingProps {
  score: number;
  size?: number;
}

function getScoreColor(score: number): string {
  if (score >= 80) return "var(--danger)";
  if (score >= 50) return "var(--warning)";
  return "var(--success)";
}

export function ScoreRing({ score, size = 36 }: ScoreRingProps) {
  const color = getScoreColor(score);
  const pct = Math.min(100, Math.max(0, score));
  const bg = `conic-gradient(${color} ${pct * 3.6}deg, var(--bg-surface) ${pct * 3.6}deg)`;

  return (
    <span
      className="score-ring"
      style={{ width: size, height: size, background: bg }}
      title={`Relevanz: ${Math.round(score)}`}
    >
      <span className="score-ring-value">{Math.round(score)}</span>
    </span>
  );
}
